import { Input } from "components/Form/components/Input/Input";
import { FormComponentProps } from "../FormComponentProps";
import { formatContentType } from "./fileMeta";

/**
 * Read-only display of a FILE's server-detected content_type. Empty / undetected
 * (e.g. legacy files written before the column existed) renders an em-dash
 * instead of "null".
 * (operator-task-fe-file-screen-humanreadable-size-and-content-type)
 */
export const ContentTypeFormComponent = ({ input, meta, fieldProps, fieldAttr }: FormComponentProps) => (
    <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
        {formatContentType(input.value)}
    </Input>
);
